import { UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './InfrastructureFromBuilder.css';
import { RateCard } from '../RateCard';
import { RateMark } from '../RateMark';

export interface IInfrastructureTerm {
  done: boolean;
  title: string;
}

export interface IInfrastructureFromBuilderProps {
  description: string;
  iconUrl: string;
  maxRate: string;
  rate: string;
  terms: IInfrastructureTerm[];
  title: string;
}

export const InfrastructureFromBuilder: React.VFC<IInfrastructureFromBuilderProps> = ({
  description,
  iconUrl,
  rate,
  maxRate,
  terms,
  title,
}) => {
  return (
    <RateCard
      title={title}
      description={description}
      rateMark={<RateMark iconUrl={iconUrl} rate={rate} maxRate={maxRate} />}
      dataTestId="InfrastructureFromBuilder"
    >
      <ul className={styles['terms']} data-testid="InfrastructureFromBuilderTerms">
        {terms.map((term, idx) => (
          <li key={idx} className={classNames(styles['term-item'], term.done && styles['term-item__done'])}>
            <UIText2 color="current_color">{term.title}</UIText2>
          </li>
        ))}
      </ul>
    </RateCard>
  );
};
